import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'

import { karaokeText } from './animations'
import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type KaraokeTextProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme: WPPageData['acf']['theme']
    paragraph: string
  }>

const KaraokeText = ({
  theme,
  paragraph,
  className,
  ...props
}: KaraokeTextProps) => {
  return paragraph ? (
    <Motion animation={karaokeText}>
      {(motionRef) => (
        <section
          ref={motionRef}
          data-reverse
          data-fill={theme === 'dark' ? '#ffffff' : '#404040'}
          className={cn(className, 'relative z-10')}
          {...props}
        >
          <Container
            className={cn([
              {
                'bg-dark-100 text-dark-500': theme === 'light',
                'bg-dark-500 text-white': theme === 'dark'
              }
            ])}
          >
            <Grid>
              <Typography
                variant="h1"
                className={cn(
                  'col-span-4 text-center md:col-span-6 lg:col-span-10 lg:col-start-2',
                  [
                    {
                      'text-dark-600': theme === 'dark',
                      'text-dark-200': theme === 'light'
                    }
                  ]
                )}
                data-motion-karaoke
              >
                {paragraph}
              </Typography>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  ) : null
}

export default KaraokeText
